var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumber = exports.ProgressChart = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _ProggresChartLabels = _interopRequireDefault(require("./ProggresChartLabels"));
var _IntroText = require("../IntroText");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["comparisons", "current", "style"];
var formatNumber = exports.formatNumber = function formatNumber(number) {
  var dividedNumber = number / 100;
  var roundedNumber = Math.floor(dividedNumber) / 10;
  return roundedNumber.toFixed(1);
};
var ProgressChart = exports.ProgressChart = function ProgressChart(_ref) {
  var comparisons = _ref.comparisons,
    current = _ref.current,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var styles = (0, _styles.useStyles)();
  var target = comparisons.target,
    global = comparisons.global,
    region = comparisons.region,
    is_global = comparisons.is_global;
  var max = Math.max(global == null ? void 0 : global.max, region == null ? void 0 : region.max, current, global == null ? void 0 : global.g_co2e, region == null ? void 0 : region.g_co2e) + 1000000;
  var allLabels = [{
    label: target == null ? void 0 : target.title,
    value: target == null ? void 0 : target.g_co2e
  }, {
    label: t('progressChart:labels.regionAverage', {
      regionTitle: global == null ? void 0 : global.title
    }),
    value: global == null ? void 0 : global.g_co2e
  }, {
    label: t('progressChart:labels.you'),
    value: current
  }].sort(function (a, b) {
    return a.value - b.value;
  });
  if (!is_global) {
    allLabels.push({
      label: t('progressChart:labels.regionAverage', {
        regionTitle: region == null ? void 0 : region.title
      }),
      value: region == null ? void 0 : region.g_co2e
    });
  }
  var _computePartialBarStyle = function _computePartialBarStyle(labelValue) {
    var widthPercentage = labelValue / max * 100;
    return {
      width: "".concat(widthPercentage, "%")
    };
  };
  var average = is_global ? global.g_co2e : region == null ? void 0 : region.g_co2e;
  var percentLower = (average - current) / average * 100;
  var regionTitle = is_global ? t('progressChart:labels.global') : region == null ? void 0 : region.title;
  return (0, _jsxRuntime.jsxs)(_reactNative.View, Object.assign({
    style: style
  }, props, {
    testID: "ProgressChart",
    children: [(0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: styles.container,
      testID: "ProgressChartContainer",
      children: [(0, _jsxRuntime.jsx)(_ProggresChartLabels["default"], {
        labels: allLabels,
        max: max
      }), (0, _jsxRuntime.jsx)(_reactNative.View, {
        style: styles.progressContainer,
        testID: "ProgressContainer",
        children: (0, _jsxRuntime.jsx)(_reactNative.View, {
          style: [styles.progressBar, _computePartialBarStyle(current)],
          testID: "ProgressBar"
        })
      })]
    }), (0, _jsxRuntime.jsx)(_IntroText.IntroText, {
      children: t('progressChart:text', {
        current: formatNumber(current / 1000),
        percentLower: Math.abs(percentLower).toFixed(0),
        level: percentLower > 0 ? 'lower' : 'higher',
        regionTitle: regionTitle,
        averageValue: formatNumber(average / 1000)
      })
    })]
  }));
};